<template>
  <div id="app">
    <keep-alive>
      <router-view :key="getRouteKey" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view :key="getRouteKey" v-if="!$route.meta.keepAlive" />
    <!-- <router-view /> -->
  </div>
</template>
<script>
import { on, off } from "view-design/src/utils/dom";
import { setMatchMedia } from "view-design/src/utils/assist";

import { mapState, mapMutations, mapActions } from "vuex";
import { GetRoleMenuList } from "@api/account";
import { Modal } from "view-design";

import store from "@/store/index";
import Setting from "@/setting";
import router from "@/router";

setMatchMedia();

export default {
  name: "app",
  computed: {
    getRouteKey() {
      // 当前路由的唯一key
      return this.$route.fullPath;
    },
  },
  methods: {
    ...mapMutations("admin/layout", ["setDevice"]),
    ...mapActions("user", ["setUser"]),
    handleWindowResize() {
      this.handleMatchMedia();
    },
    handleMatchMedia() {
      const matchMedia = window.matchMedia;

      if (matchMedia("(max-width: 600px)").matches) {
        this.setDevice("Mobile");
      } else if (matchMedia("(max-width: 992px)").matches) {
        this.setDevice("Tablet");
      } else {
        this.setDevice("Desktop");
      }
    },
    // 获取用户菜单列表
    async getRoleMenuList() {
      var menuAccess = [];
      var bcosMenuAccess = [];
      await GetRoleMenuList().then((res) => {
        if (res && res.code == 200) {
          var menuList =
            res.data.menuInfoList && res.data.menuInfoList.length > 0
              ? res.data.menuInfoList
              : [];
          if (menuList.length > 0) {
            menuList.forEach((item) => {
              const pre = item.path;
              // 按钮级权限
              if (pre == router.currentRoute.fullPath) {
                router.currentRoute.meta.btns = item.btns ? item.btns : {};
              }

              menuAccess.push(`${pre}`);

              if (item.children && item.children.length > 0) {
                item.children.forEach((citem) => {

                  if (citem.path == router.currentRoute.fullPath) {
                    // 子路由 - 按钮级权限
                    router.currentRoute.meta.btns = citem.btns
                      ? citem.btns
                      : {};
                  }

                  menuAccess.push(`${citem.path}`);
                  let cPre = citem.path;
                  if (cPre.startsWith("/bcos/")) {
                    bcosMenuAccess.push(`${cPre}`);
                  }
                });
              }

              if (pre.startsWith("/bcos/")) {
                bcosMenuAccess.push(`${pre}`);
              }
            });
          }
        }

        // initAccess
        // let initAccessList = [
        //   "/basic",
        //   "/basic/account",
        //   "/basic/authority",
        //   "/basic/menu",
        // ];
        // menuAccess = menuAccess.concat(initAccessList);

        if (menuAccess.length == 0) {
          // this.$Message.warning("抱歉，你无权访问该平台！");

          return;
        }
        //无法后台配置权限
        menuAccess = menuAccess.concat(["/setting", "/setting/self"]);

        var userInfo = {};
        userInfo.menuAccess = menuAccess;
        // userInfo.bcosMenuAccess = bcosMenuAccess;
        userInfo.bcosMenuLength = bcosMenuAccess.length;



        // 持久化存储
        store.dispatch("admin/user/set", userInfo, {
          root: true,
        });
        // 用户登录后从持久化数据加载一系列的设置
        store.dispatch("admin/account/load", {
          loadOpenedTabs: Setting.page.loadOpenedTabs,
        });
        // // 重定向对象不存在则返回顶层路径
        // this.$router.replace(this.$route.query.redirect || "/");
      });

    },
    // 根据fullUrl清除keepAlive
    clearKeepAlive(fullUrl) {
      this.$children.forEach((item) => {
        if (item.$vnode.data.key == fullUrl) {
          this._myDestory(item);
        }
      });
    },
    // 封装清除某个组件的keepAlive状态,并销毁
    _myDestory(keepAliveComponent) {
      // 你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。
      if (
        keepAliveComponent.$vnode &&
        keepAliveComponent.$vnode.data.keepAlive
      ) {
        if (
          keepAliveComponent.$vnode.parent &&
          keepAliveComponent.$vnode.parent.componentInstance &&
          keepAliveComponent.$vnode.parent.componentInstance.cache
        ) {
          if (keepAliveComponent.$vnode.componentOptions) {
            var key =
              keepAliveComponent.$vnode.key == null
                ? keepAliveComponent.$vnode.componentOptions.Ctor.cid +
                  (keepAliveComponent.$vnode.componentOptions.tag
                    ? `::${keepAliveComponent.$vnode.componentOptions.tag}`
                    : "")
                : keepAliveComponent.$vnode.key;
            var cache =
              keepAliveComponent.$vnode.parent.componentInstance.cache;
            var keys = keepAliveComponent.$vnode.parent.componentInstance.keys;
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key);
                if (index > -1) {
                  keys.splice(index, 1);
                }
              }
              delete cache[key];
            }
          }
        }
      }
      keepAliveComponent.$destroy();
    },
  },
  mounted() {
    on(window, "resize", this.handleWindowResize);
    this.handleMatchMedia();

    // 注册监听全局的clearKeepAlive方法,可在其他组件中触发此方法
    this.$Bus.$on("toClearKeepAlive", this.clearKeepAlive);


  },
  watch: {
    $route(to, from) {
      // 权限相关
      let { token } = store.state.user.profile;
      if (token && token != "") {
        // 获取用户菜单列表
        this.getRoleMenuList();
      }
    },
  },

  beforeDestroy() {
    off(window, "resize", this.handleWindowResize);
  },
};
</script>

<style lang="less">
.vxe-cell {
  user-select: all;
}

.ivu-description-term {
  min-width: 100px;
}
.aStyle {
  color: #006eff;
  cursor: pointer;
}
.aStyle:hover {
  text-decoration: underline;
}
// 新建区块链 - 节点部署配置，单元格提示 - 隐藏
.vxe-table--tooltip-wrapper.vxe-table--valid-error,
.vxe-cell--valid {
  height: 0 !important;
  overflow: hidden;
  visibility: hidden;
}

.chain-net-bg {
  margin: 16px auto;
}

.chain-net-title-icon {
  position: relative;
  top: -2.5px;
  left: -2px;
}

.chain-net-chainName {
  position: relative;
  top: 2px;
  left: 5px;
  overflow: hidden;
  display: inline-block;
  width: 68%;
  height: 18px;
  line-height: 18px;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.margin-left12 {
  margin-left: 13px;
}

.cursor {
  cursor: pointer;
}
</style>